import { render, staticRenderFns } from "./ShowStudent.vue?vue&type=template&id=d2ac2368&scoped=true"
import script from "./ShowStudent.vue?vue&type=script&lang=js"
export * from "./ShowStudent.vue?vue&type=script&lang=js"
import style0 from "./ShowStudent.vue?vue&type=style&index=0&id=d2ac2368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ac2368",
  null
  
)

export default component.exports